import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface CreateItemProps {
  onSubmit: ({ }: any) => void;
}

const CreateItem: React.FC<CreateItemProps> = ({ onSubmit }) => {

  return (
    <div className="createItemContainer" onClick={onSubmit}>
      <FontAwesomeIcon icon={faPlusSquare} size={'1x'} />
      <span className="p-ml-3" >Adicionar item</span>
    </div>
  );
}

export default CreateItem;
